import { useCookieConsent } from '../../components/feature/CookieConsent';
import LegalPageLayout, {
  LegalList,
  LegalSection,
} from '../../components/feature/LegalPageLayout';
import { LEGAL_UPDATED_AT } from '../../lib/legalInfo';

const cookieRows = [
  {
    name: 'kf_cookie_consent',
    purpose: 'Uloženie voľby súhlasu s cookies a nastavení preferencií.',
    duration: '180 dní',
    type: 'Nevyhnutná cookie',
  },
  {
    name: '_ga',
    purpose: 'Rozlíšenie návštevníkov v Google Analytics 4 a meranie návštevnosti.',
    duration: 'spravidla do 2 rokov',
    type: 'Analytická cookie',
  },
  {
    name: '_ga_<ID>',
    purpose: 'Udržiavanie stavu relácie a meraní pre konkrétnu GA4 property.',
    duration: 'spravidla do 2 rokov',
    type: 'Analytická cookie',
  },
  {
    name: '_gid',
    purpose: 'Základné rozlíšenie návštev v kratšom časovom okne pre analytiku.',
    duration: 'spravidla 24 hodín',
    type: 'Analytická cookie',
  },
  {
    name: '_gat / _gat_gtag_<ID>',
    purpose: 'Krátkodobé obmedzenie počtu požiadaviek pri meraní návštevnosti.',
    duration: 'spravidla 1 minúta',
    type: 'Analytická cookie',
  },
];

export default function CookiesPage() {
  const { openSettings } = useCookieConsent();

  return (
    <LegalPageLayout
      badge="Cookies"
      badgeIcon="ri-settings-5-line"
      title="Cookies"
      lead="Táto stránka vysvetľuje, aké cookies používam, na aký účel ich používam a ako môžete svoj súhlas udeliť, odmietnuť alebo neskôr zmeniť."
      supporting="Analytické cookies sa na tomto webe aktivujú až po Vašom výslovnom súhlase. Nevyhnutné cookies sú potrebné pre fungovanie stránky a správu Vášho rozhodnutia."
      lastUpdated={LEGAL_UPDATED_AT}
    >
      <LegalSection title="1. Čo sú cookies">
        <p>
          Cookies sú malé textové súbory, ktoré sa ukladajú do Vášho zariadenia
          pri návšteve webovej stránky. Pomáhajú napríklad zapamätať si nastavenia,
          rozlíšiť reláciu alebo získať anonymizované štatistiky návštevnosti.
        </p>
      </LegalSection>

      <LegalSection title="2. Aké typy cookies používam">
        <LegalList
          items={[
            'Nevyhnutné cookies: zabezpečujú základné fungovanie webu a ukladajú Vašu voľbu súhlasu.',
            'Analytické cookies: používajú sa len na základe Vášho súhlasu a pomáhajú mi pochopiť, ako návštevníci web používajú.',
          ]}
        />
      </LegalSection>

      <LegalSection title="3. Zoznam používaných cookies">
        <div className="overflow-hidden rounded-[24px] border border-white/10 bg-black/18">
          <div className="grid grid-cols-1 divide-y divide-white/8 md:grid-cols-[1.1fr_1.7fr_0.9fr_0.9fr] md:divide-x md:divide-y-0">
            {['Cookie', 'Účel', 'Trvanie', 'Typ'].map((heading) => (
              <div
                key={heading}
                className="bg-white/[0.04] px-5 py-4 text-xs font-semibold uppercase tracking-[0.16em] text-white/48"
              >
                {heading}
              </div>
            ))}
          </div>

          {cookieRows.map((row) => (
            <div
              key={row.name}
              className="grid grid-cols-1 border-t border-white/8 md:grid-cols-[1.1fr_1.7fr_0.9fr_0.9fr]"
            >
              <div className="px-5 py-4 font-mono text-sm text-white/82">{row.name}</div>
              <div className="px-5 py-4 text-sm leading-7 text-white/68">{row.purpose}</div>
              <div className="px-5 py-4 text-sm text-white/68">{row.duration}</div>
              <div className="px-5 py-4 text-sm text-white/68">{row.type}</div>
            </div>
          ))}
        </div>
      </LegalSection>

      <LegalSection title="4. Google Analytics 4">
        <p>
          Ak udelíte súhlas s analytickými cookies, web používa Google Analytics 4
          na meranie návštevnosti, výkonu stránok a základných trendov používania.
          Analytika je nastavená tak, aby sa nenačítala bez súhlasu.
        </p>
        <p>
          Poskytovateľom analytickej služby je Google. V súvislosti s používaním
          analytiky môže dochádzať aj k prenosu údajov mimo EÚ alebo EHP podľa
          aktuálneho právneho rámca a nastavení tejto služby.
        </p>
      </LegalSection>

      <LegalSection title="5. Ako môžete cookies spravovať">
        <p>
          Cookies môžete spravovať priamo cez nastavenia cookies na tomto webe.
          Svoj súhlas môžete kedykoľvek zmeniť alebo analytické cookies odmietnuť.
        </p>
        <div className="pt-2">
          <button
            type="button"
            onClick={openSettings}
            className="inline-flex items-center justify-center rounded-[18px] border border-brand-green/20 bg-white/[0.05] px-5 py-3.5 text-sm font-semibold text-brand-green transition-all hover:border-brand-green/32 hover:bg-brand-green/[0.08]"
          >
            Otvoriť nastavenia cookies
          </button>
        </div>
      </LegalSection>

      <LegalSection title="6. Ďalšie informácie">
        <p>
          Podrobnosti o spracúvaní osobných údajov nájdete na stránke Ochrana
          osobných údajov. Ak máte otázky k cookies alebo k súhlasu, môžete ma
          kontaktovať cez kontaktný formulár alebo e-mail uvedený na webe.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
